import { RingStates } from './enums/ring-states';
import { RuleTargetTypes } from './enums/rule-target-types';

export class Rule {
    public id: string;
    public enabled: boolean;
    public extensionId: string = '';
    public organizationId: string;
    public ringState: RingStates;
    public ringSeconds: number;
    public targetType: RuleTargetTypes;
    public target: string;
    public calendarId: string;
}
